import { StatusCreate } from './create'

export const StatusEdit = StatusCreate
